import React, { useContext, useEffect, useRef, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import {
  getBrandStore,
  getBrandUsers,
} from "../../../services/StoreUsers/PostStoreUsers";
import { formatDate, formatDateWithTime, localeDateEndDate, localeDateStartDate } from "../../../constants/DateUtil/DateUtil";
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { getBrandWarehouse } from "../../../services/warehouse/Warehouse";
import AdminMenu from "../../AdminMenu";
import { addPromotionRegister, addPromotionRegisterWithId, getBrandWhatsappConfig, getPromotionAddFailedCredit, getPromotionCheckFailedCredit, getPromotionList, getViewPromoTemplate } from "../../../services/PromoTemplate/PromoTemplate";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import PromoStatusFilterModal from "./PromoStatusFilterModal";
import PromoSchedularModal from "./PromoSchedularModal";
import PromoTemplateTypeFilterModal from "./PromoTemplateTypeFilterModal";
import { DataScroller } from "primereact/datascroller";
import PromoTemplateIdFilterModal from "./PromoTemplateIdFilterModal";
import PromoTemplateIdCreditModal from "./PromoTemplateIdCreditModal";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { FloatLabel } from "primereact/floatlabel";
const { innerWidth: width, innerHeight: height } = window;

const PromoTemplateView = () => {
  const navigate = useNavigate();
  const [promotionInfoData, setPromotionInfoData] = useState([]);
  const [visible, setVisible] = useState(false);

  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;
  const [loading, setLoading] = useState(false);
  const [promoTemplateList, setPromoTemplateList] = useState([]);

  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  const [statusFilterModalVisible, setStatusFilterModalVisible] =
    useState(false);
  const [templateTypeFilterModalVisible, setTemplateTypeFilterModalVisible] =
    useState(false);
  const [templateIdFilterModalVisible, setTemplateIdFilterModalVisible] =
    useState(false);
  const [templateIdCreditModalVisible, setTemplateIdCreditModalVisible] =
    useState(false);

  const [selectPromotionData, setSelectPromotionData] = useState({});

  const handleCalendarModal = () => {
    setSchedularModalVisible(true);
  };

  const handleFilterModal = () => {
    setStatusFilterModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };
  const handleTemplateTypeFilterModal = () => {
    setTemplateTypeFilterModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };
  const handleTemplateIdFilterModal = () => {
    setTemplateIdFilterModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };

  const handleTemplateIdCreditModal = () => {
    setTemplateIdCreditModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };

  const [promotionCreditData, setPromotionCreditData] = useState([])

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate()); // subtract 7 days to current date

  let initialEndDate = new Date();
  initialEndDate.setDate(initialEndDate.getDate() + 30); // subtract 7 days to current date

  const [selectedStatus, setSelectedStatus] = useState("ALL"); // Default to show all orders
  const [selectedTemplateType, setSelectedTemplateType] = useState("ALL"); // Default to show all orders
  const [selectedTemplateId, setSelectedTemplateId] = useState("ALL"); // Default to show all orders

  const [page, setPage] = useState(0);
  const [schedularDate, setSchedularDate] = useState({});
  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setUseEffectCall(true);
    setPage(0);
    setSchedularDate(newSchedular);
  };

  const receiveDataFromStatusFilterModal = (selectedStatus) => {
    setUseEffectCall(true);
    setPage(0);
    setSelectedStatus(selectedStatus);
  };

  const receiveDataFromTemplateTypeFilterModal = (selectedTemplateType) => {
    setUseEffectCall(true);
    setPage(0);
    setSelectedTemplateType(selectedTemplateType);
  };

  const receiveDataFromTemplateIdFilterModal = (selectedTemplateId) => {
    setUseEffectCall(true);
    setPage(0);
    setSelectedTemplateId(selectedTemplateId);
  };

  const [fileName, setFileName] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [displayCustomerUpload, setDisplayCustomerUpload] = useState(false);
  const [submitButtonPressed, setSubmitButtonPressed] = useState(false);
  const [promoTemplate, setPromoTemplate] = useState("");
  const [promoTemplateError, setPromoTemplateError] = useState("");


  const minimumDate = new Date();

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3);

  const [startDateTemplate, setStartDateTemplate] = useState(new Date());



  const onClickCustomerUpload = () => {
    setDisplayCustomerUpload(true);
  };
  const onHideCustomerUpload = () => {
    setFileName("");
    setSelectedImage(null);
    setDisplayCustomerUpload(false);
  };


  const handleCustomerDownload = () => {
    const link = document.createElement("a");
    link.href = "/promotion_filedata.xlsx"; // File path inside public folder
    link.download = "promotion_filedata.xlsx"; // Rename file on download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [isEndReached, setIsEndReached] = useState(false);
  const ds = useRef(null);
  const [useEffectCall, setUseEffectCall] = useState(false);

  const initializeVariable = () => {
    setPromotionInfoData([]);
  };

  const fetchPromotion = (data, page = 0) => {
    setLoading(true);
    getViewPromoTemplate(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const templateIds = Res.map((item) => item.id);
          setPromoTemplateList(Res);
          getPromotionList({
            ...data,
            templateIds: templateIds,
            limit: 10,
            offset: page * 10, // Ensure offset is correctly applied
          })
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (page === 0) {
                  setPromotionInfoData(Res);
                } else {
                  setPromotionInfoData((prevData) => {
                    const existingIds = new Set(
                      prevData.map((item) => item.id)
                    );
                    const newUniqueData = Res.filter(
                      (item) => !existingIds.has(item.id)
                    );
                    const updatedData = [...prevData, ...newUniqueData];

                    return updatedData;
                  });
                }

                setLoading(false);
                // setSearchTermClean(false);
                setIsEndReached(Res.length < 100);
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const data = {
    brandId: brandId,
    sortBy: "id",
    sortOrder: 'desc',
    // startDate: startDate, // startDate
    // endDate: endDate, // endDate
    templateTypeIn: ["TEXT", "IMAGE"], // template type filter
    // templateIds: [1, 2], // view-promo-template filter
    statusIn: ["SCHEDULED", "RUNNING", "LOW_PROMO_BALANCE", "DONE", "CANCEL"], // status filter
  };

  const [requestData, setRequestData] = useState(data);
  const [brandWhatsappConfig, setBrandWhatsappConfig] = useState({});

  useEffect(() => {
    fetchPromotion(data, 0);

    getBrandWhatsappConfig(brandId)
      .then((response) => {
        if (!response.data.error) {
          const config = response.data;
          setBrandWhatsappConfig(config);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    // getPromotionAddFailedCredit(12)
    //   .then((response) => {
    //     if (!response.data.error) {
    //       const config = response.data;
    //       // setBrandWhatsappConfig(config);
    //     }
    //   })
    //   .catch((err) => {
    //     console.error("Error:", err);
    //   });


  }, []);


  const fetchPromotionCredit = (promotionId) => {
    getPromotionCheckFailedCredit(promotionId)
      .then((response) => {
        if (!response.data.error) {
          const dataList = response.data;
          setPromotionCreditData(dataList);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  }

  useEffect(() => {
    if (useEffectCall) {
      initializeVariable();
      if (selectedStatus !== "ALL") {
        requestData.statusIn = selectedStatus;
      } else {
        requestData.statusIn = [
          "SCHEDULED",
          "RUNNING",
          "LOW_PROMO_BALANCE",
          "DONE",
          "CANCEL",
        ];
      }

      if (selectedTemplateType !== "ALL") {
        requestData.templateTypeIn = selectedTemplateType;
      } else {
        requestData.templateTypeIn = ["TEXT", "IMAGE"];
      }
      requestData.startDate = schedularDate?.startDate
        ? localeDateStartDate(new Date(schedularDate.startDate))
        : localeDateStartDate(new Date(startDate));
      requestData.endDate = schedularDate?.endDate
        ? localeDateEndDate(new Date(schedularDate.endDate))
        : localeDateEndDate(new Date(endDate));
      setPage(0);
      fetchPromotion(requestData, page);
    }
  }, [schedularDate, selectedStatus, selectedTemplateType]);

  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const requestValue = {
      ...requestData,
    };
    if (page > 0) fetchPromotion(requestValue, page);
  }, [page]);

  const getData = () => {
    if (!isEndReached && !loading) {
      setPage((prevPage) => prevPage + 1);
      ds.current.load();
    }
  };


  const receiveDataFromPromotionRollbackModal = (selectedStatus) => {
    setUseEffectCall(true);
    setPage(0);
    fetchPromotion(data, 0);
  };


  const filterPromotionList = () => {
    return promotionInfoData.filter((item) => {
      const search = searchTerm.toLowerCase();

      const status = item.status?.toLowerCase() || "";
      const templateName =
        item?.brandPromoTemplate?.templateName?.toLowerCase() || "";

      return (
        status.includes(search) ||
        templateName.includes(search)
      );
    });
  };

  const filteredPromotionData = filterPromotionList();

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const handleFileChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    setFileName(file ? file.name : ""); // Update the file name or clear it if no file is selected

    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    } else {
      setSelectedImage(null);
    }
  };

  const renderDialogCustomerUpload = () => (
    <Dialog
      header="Customer Upload"
      visible={displayCustomerUpload}
      onHide={() => onHideCustomerUpload()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "50vw" }}
    >
      <div>
        <form onSubmit={handleCustomerUpload}>
          <div className="row mb-3">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <button
                onClick={handleCustomerDownload}
                style={{
                  padding: "10px",
                  background: "blue",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Download Sample File
              </button>
              <div>
                <label for="file-upload" className="custom-file-upload">
                  <i className="pi pi-upload"></i> Choose Customer File
                </label>
                <input
                  id="file-upload"
                  type="file"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
              </div>
              <div>
                <i
                  className="pi pi-file"
                  style={{ color: "blue", fontSize: "40px" }}
                ></i>
                {fileName && (
                  <p
                    style={{
                      alignSelf: "center",
                      fontSize: 14,
                      fontWeight: 600,
                      margin: 10,
                    }}
                  >
                    {fileName}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
                <p className="text-md " style={{color:'red'}}>* Upload Customer Mobile No. Without Country Code.</p>
            </div>
          </div>
          <div className="flex flex-1 mb-3">
            <div className="mx-4 mt-4 flex-1">
              <FloatLabel>
                <Dropdown
                  id="promoTemplate"
                  value={promoTemplate}
                  onChange={(e) =>
                    setPromoTemplate(e.target.value)
                  }
                  options={promoTemplateList}
                  optionLabel="templateName"
                  placeholder="Promo Template"
                  className="w-full border-round-xl text-xl shadow-2"
                />

                <label
                  htmlFor="promoTemplate"
                  className="text-md"
                  style={{ color: "blue" }}
                >
                  Promo Template{" "}
                  <span style={{ color: "red" }}>
                    *
                  </span>
                </label>
              </FloatLabel>

              {promoTemplateError && (
                <p style={{ color: "red" }}>
                  {promoTemplateError}
                </p>
              )}
            </div>

            {/* Calendar */}

            <div className="mx-4 mt-4 flex-1">
              <Calendar
                value={startDate}
                onChange={(e) =>
                  setStartDate(e.value)
                }
                showTime
                hourFormat="12"
                minDate={minimumDate}
                maxDate={maximumDate}
                dateFormat="dd/mm/yy"
                className="w-full"
              />
            </div>
          </div>
          {selectedImage && (
            <div className="col-md-12 text-center">
              <Button
                type="submit"
                disabled={submitButtonPressed}
              >
                Submit
              </Button>
            </div>
          )}
        </form>
      </div>
    </Dialog>
  );


  const handleCustomerUpload = (event) => {
    event.preventDefault();
    const fileInput = event.target.querySelector('input[type="file"]');
    const uploadFile = fileInput.files[0];

    if (!uploadFile) {
      console.error("No file selected");
      return;
    }

    const payload = {
      brandTemplateId: promoTemplate.id,
      startOn: localeDateStartDate(new Date(startDateTemplate)),
    };

    setSubmitButtonPressed(true);
    

    addPromotionRegister(payload)
      .then((response) => {
        const Res = response.data;
        // handle the response
        if (Res.status === true) {

          addPromotionRegisterWithId(uploadFile, Res?.message)
            .then((response) => {
              const Res = response.data;
              // handle the response
              if (Res.status === true) {

                setFileName("");
                setSelectedImage(null);
                setDisplayCustomerUpload(false);

                fetchPromotion(data, 0);
                setSubmitButtonPressed(false);

                getBrandWhatsappConfig(brandId)
                  .then((response) => {
                    if (!response.data.error) {
                      const config = response.data;
                      setBrandWhatsappConfig(config);
                    }
                  })
                  .catch((err) => {
                    console.error("Error:", err);
                  });
              } else {

                setFileName("");
                setSelectedImage(null);
                setDisplayCustomerUpload(false);

                fetchPromotion(data, 0);
                setSubmitButtonPressed(false);

                getBrandWhatsappConfig(brandId)
                  .then((response) => {
                    if (!response.data.error) {
                      const config = response.data;
                      setBrandWhatsappConfig(config);
                    }
                  })
                  .catch((err) => {
                    console.error("Error:", err);
                  });
              }
            })
            .catch((error) => {
              // handle errors

              setFileName("");
              setSelectedImage(null);
              setDisplayCustomerUpload(false);

              fetchPromotion(data, 0);
              setSubmitButtonPressed(false);

              getBrandWhatsappConfig(brandId)
                .then((response) => {
                  if (!response.data.error) {
                    const config = response.data;
                    setBrandWhatsappConfig(config);
                  }
                })
                .catch((err) => {
                  console.error("Error:", err);
                });
            });
          setFileName("");
          setSelectedImage(null);
          setDisplayCustomerUpload(false);

          fetchPromotion(data, 0);
          setSubmitButtonPressed(false);

          getBrandWhatsappConfig(brandId)
            .then((response) => {
              if (!response.data.error) {
                const config = response.data;
                setBrandWhatsappConfig(config);
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {

          setFileName("");
          setSelectedImage(null);
          setDisplayCustomerUpload(false);

          fetchPromotion(data, 0);
          setSubmitButtonPressed(false);

          getBrandWhatsappConfig(brandId)
            .then((response) => {
              if (!response.data.error) {
                const config = response.data;
                setBrandWhatsappConfig(config);
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      })
      .catch((error) => {
        // handle errors

        setFileName("");
        setSelectedImage(null);
        setDisplayCustomerUpload(false);
        setSubmitButtonPressed(false);
      });
  };

  const renderCardItem = (data) => {
    return (
      <div>
        <div className="flex-1 ">
          <div className="m-4 shadow-4">
            <div className="flex flex-1">
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Template Name :
                </p>
                <p className="text-lg font-medium">
                  {data.brandPromoTemplate.templateName}
                </p>
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Template Type :
                </p>
                <p className="text-lg font-medium capitalize">
                  {data.brandPromoTemplate.templateType}
                </p>
              </div>
              <div
                className="flex-1 px-3 py-1 flex justify-content-between"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <div>
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    status :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {data.status}
                  </p>
                </div>
                <div className="flex justify-content-center align-items-center">
                  <Button
                    label={"View"}
                    onClick={() => {
                      handleTemplateIdCreditModal()
                      fetchPromotionCredit(data.id)
                      setSelectPromotionData(data);
                    }}
                    className=" text-lg w-full border-round-lg p-1 mx-2"
                    style={{
                      color: "#2B70D7",
                      backgroundColor: "#fff",
                      borderColor: "#2B70D7",
                    }}
                  ></Button>
                </div>

                {data.status === "SCHEDULED" && <div
                  className="mr-4 mt-2"
                  onClick={() =>
                    navigate("/PromoTemplateCreate", {
                      state: {
                        item: data,
                      },
                    })
                  }
                >
                  <i
                    className="pi pi-pencil"
                    style={{
                      fontSize: "25px",
                      cursor: "pointer",
                      color: "#2B70D7",
                    }}
                  ></i>
                </div>}
              </div>
            </div>
            <div className="flex flex-1">
              <div
                className="flex-1 px-3 py-1 flex justify-content-between"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <div>
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Total Customer Count :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {data.totalCustomerCount}
                  </p>
                </div>
                <div
                  className=" mt-2"
                  onClick={() =>
                    navigate("/PromoTemplateCustomerView", {
                      state: {
                        item: data,
                      },
                    })
                  }
                >
                  <i
                    className="pi pi-eye"
                    style={{
                      fontSize: "15px",
                      cursor: "pointer",
                      color: "#2B70D7",
                    }}
                  ></i>
                </div>
              </div>
              <div
                className=" px-3 py-1"
                style={{
                  flex: 1,
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  startOn:
                </p>
                <p className="text-lg font-medium capitalize">
                  {formatDateWithTime(data.startOn)}
                </p>
              </div>
              <div
                className=" px-3 py-1"
                style={{
                  flex: 1,
                  backgroundColor: "#E2F4F8",
                }}
              >

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Promotion Management
              </p>
            </div>
          </div>

          <div className="flex justify-content-center align-items-center">
            <Button
              label={"Your Promo Left Count : " + brandWhatsappConfig?.promoLeftCount}
              className=" text-lg w-full border-round-lg p-1 mx-2"
              style={{
                color: "#2B70D7",
                backgroundColor: "#fff",
                borderColor: "#2B70D7",
              }}
            ></Button>
          </div>
          <Button
            type="button"
            className="btn"
            onClick={() =>
              onClickCustomerUpload()
            }
          >
            <i
              className="pi pi-upload"
              style={{ color: "#fff", fontSize: "20px" }}
            ></i>
          </Button>
          <div
            onClick={() =>
              navigate("/PromoTemplateCreate", {
                state: {
                  item: null,
                },
              })
            }
            className="mx-2 cursor-pointer"
          >
            <img
              src={
                "images/plus.png"
              }
              style={{ width: 27, }}
            />
          </div>
          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>

          <div
            onClick={() => handleFilterModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: 27 }}
            />
          </div>
          <div
            onClick={() => handleTemplateTypeFilterModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: 27 }}
            />
          </div>

          <div
            onClick={() => handleTemplateIdFilterModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: 27 }}
            />
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="my-2 mx-4 flex flex-1">
        <div className="flex-1">
          <IconField iconPosition="left" className="flex flex-1">
            <InputIcon className="pi pi-search text-xl"> </InputIcon>
            <InputText
              placeholder={
                "Search Promotion Name Here"
              }
              value={searchTerm}
              keyboardType={
                "default"
              }
              onChange={(e) => setSearchTerm(e.target.value)}
              className="text-xl flex flex-1 py-1 px-5"
              style={{ borderRadius: 30 }}
            />
          </IconField>
        </div>

        {searchTerm && (
          <div
            className="flex justify-content-center align-items-center mx-2 cursor-pointer"
            onClick={handleClearSearch}
          >
            <p className="text-3xl font-bold " style={{ color: "red" }}>
              X
            </p>
          </div>
        )}
      </div>

      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : promotionInfoData?.length > 0 ? (
          <div>
            <DataScroller
              value={filteredPromotionData || promotionInfoData}
              itemTemplate={renderCardItem}
              rows={filteredPromotionData?.length + 100}
              inline
              ref={ds}
              scrollHeight={height > 600 ? "550px" : "500px"}
              loader
            // footer={footer}
            />
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Promotion Found</p>
          </div>
        )}
      </div>

      <div
        className="flex justify-content-center fixed "
        style={{ bottom: 10, left: 20 }}
      >
        <Button
          type="text"
          icon="pi pi-plus"
          // label="More"
          onClick={getData} // Update this to trigger `getData`
        />
      </div>

      <PromoSchedularModal
        setSchedularModalVisible={setSchedularModalVisible}
        schedularModalVisible={schedularModalVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModal}
      />
      <PromoStatusFilterModal
        setStatusFilterModalVisible={setStatusFilterModalVisible}
        statusFilterModalVisible={statusFilterModalVisible}
        sendDataToOrdersPageFromFilter={receiveDataFromStatusFilterModal}
        OrderStatus={[
          "SCHEDULED",
          "RUNNING",
          "LOW_PROMO_BALANCE",
          "DONE",
          "CANCEL",
        ]}
      />

      <PromoTemplateTypeFilterModal
        setTemplateTypeFilterModalVisible={setTemplateTypeFilterModalVisible}
        templateTypeFilterModalVisible={templateTypeFilterModalVisible}
        sendDataToOrdersPageFromFilter={receiveDataFromTemplateTypeFilterModal}
        OrderTemplateType={["TEXT", "IMAGE"]}
      />
      <PromoTemplateIdFilterModal
        setTemplateIdFilterModalVisible={setTemplateIdFilterModalVisible}
        templateIdFilterModalVisible={templateIdFilterModalVisible}
        sendDataToOrdersPageFromFilter={receiveDataFromTemplateIdFilterModal}
        OrderTemplateId={promoTemplateList}
      />
      <PromoTemplateIdCreditModal
        setTemplateIdCreditModalVisible={setTemplateIdCreditModalVisible}
        templateIdCreditModalVisible={templateIdCreditModalVisible}
        promoTemplateIdCreditList={promotionCreditData}
        selectPromotionData={selectPromotionData}
        sendDataToOrdersPageFromFilter={receiveDataFromPromotionRollbackModal}
      />

      <AdminMenu setVisible={setVisible} visible={visible} />
      <div>{renderDialogCustomerUpload()}</div>
    </div>
  );
};

export default PromoTemplateView;
